import React from 'react'
import project from '../../project'
// import Data from './Data'
import { Tracking } from '../../../NodeModules/nnd-track-page'
import axios from 'axios';
import "../assets/styles/home.scss"

let environment = (location.hostname === "localhost") ? 'DEV' : 'PROD'; // PROD or DEV
const apiURL_storage_data = 'https://news-networkeditorial.s3.ap-southeast-2.amazonaws.com/interactives/AFLphantomDraft2025/prod/AFLphantomDraft2025.json'

/* LOAD READER RANKING */
let sortByKey = (array, key, ascdesc) => {
  return array.sort((a, b) => {
    let x = (ascdesc === 'asc') ? b[key] : a[key]
    let y = (ascdesc === 'asc') ? a[key] : b[key]
    return -((x < y) ? -1 : ((x > y) ? 1 : 0))
  })
}

class Home extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      view: 'expert',
      firstInteraction: false,
      votingDisabled: false,
      data: undefined
    }

    const thisState = this

    let appContainer = document.getElementById(`app_${project.name}`)
    appContainer.addEventListener('mouseenter', (f) => {
      if (!thisState.state.firstInteraction) {
        thisState.state.firstInteraction = true
        Tracking.trackPageImpression('firstinteraction', project.name)
      }
    })
    
  }

  componentDidMount () {
    this.loadData ()
  }

  loadData () {
    
    axios.get(apiURL_storage_data)
    .then((response) => {
      let titlesRemoved = response.data.values
      titlesRemoved.shift()
      const cleanData = titlesRemoved.filter( card => card.length )
      const dataPaired = cleanData.map( (player) => {
        const newPlayer = {}
        // console.log('player', player)
        newPlayer.id = parseInt(player[0])
        newPlayer.name = player[1]
        newPlayer.imagename = player[2] !== '' ? player[2] : 'default'
        newPlayer.standfirst = player[3]
        newPlayer.club = player[4]
        newPlayer.clubLogo = player[4].replaceAll(' ', '-')
        newPlayer.desc = player[5]
        newPlayer.numbers = player[6]

        return newPlayer
      });

      this.setState({
        data: dataPaired
      });

    })
    .catch((err) => {
      console.log('err', err)
    })

  }

  render() {
    const cardlist = (typeof this.state.data !== 'undefined') ? this.state.data.map((item) => {
      // console.log('item.imagename', item)
      if (typeof this.state.data !== 'undefined') {
        return (
         <div key={item.id} className={`nnd-row nnd-expert-${item.id}`}>
           <div className="nnd-col-rating"><span className="nnd-rating-expert">{ item.id }</span><span className="nnd-rating-people">{ item.peopleid }</span></div>
           <div className="nnd-col-img">
             <picture>
               <source srcSet={require(`../assets/images/${item.imagename}.jpg`)} media="(min-width: 768px)" />
               <img loading="lazy" srcSet={require(`../assets/images/${item.imagename}.jpg`)} src={require(`../assets/images/${item.imagename}.jpg`)} />
             </picture>
           </div>
           <div className="nnd-col-text">
              <img className="nnd-clubLogo" src={require(`../assets/images/${item.clubLogo}.svg`)} alt={ item.club } />
              <h3>{ item.name }</h3>
              <p>{ item.standfirst }</p>
              {item.club ? <h5><span>Drafted:</span> { item.club }</h5> : '' }
              <p><span>We say:</span> { item.desc }</p>
              {/* <p><span>The numbers say:</span> { item.numbers }</p> */}

           </div>
         </div>
        )
      }
    }) : ''

    return (
      <div className="nnd-container">
        <div className="nnd-header">
          <img alt="AFL Phantom Draft" src={require('../assets/images/header.png')} />
          <h2><span>AFL</span>Phantom Draft 2025</h2>
        </div>
        <div className="nnd-navigation-bg"></div>
        <div name="nnd-expert" className="nnd-cont-main">
          {cardlist}
        </div>
        
      </div>
    )
  }
}

export default Home


// WEBPACK FOOTER //
// ./src/components/Home.js